import en from './i18n/en.json'
import tr from './i18n/tr.json'
import dk from './i18n/dk.json'


// IMPORTANT
// frontend/app/plugins/cookieconsent.client.ts needs to be updated for new languages

export default defineI18nConfig(() => ({
  legacy: false,
  defaultLocale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    tr,
    dk
  }
}))